import Container from './MobileBatchEdit.container';
import MobileBatchEdit from './MobileBatchEdit';

export default Container(MobileBatchEdit);
